// Module
var code = `<template>
  <require from="./grid-columns-button.scss"></require>

  <button mdc-icon-button icon="settings" title="Configure columns" click.trigger="open()"></button>
</template>
`;
// Exports
export default code;